// @flow

import * as React from 'react';
import { findDOMNode } from 'react-dom';
import ReactTappable from 'react-tappable';

type Props = {
  allowReactivation?: boolean,
  moveYThreshold?: number,
  onRef?: () => void
};

class Tappable extends React.Component<Props> {
  static defaultProps = {
    allowReactivation: false,
    moveYThreshold: 5,
    onRef: undefined
  };

  render() {
    const { onRef, ...otherProps } = this.props;

    let tapRef;
    if (onRef) {
      tapRef = ref => onRef(findDOMNode(ref));
    }

    return <ReactTappable {...otherProps} ref={tapRef} />;
  }
}

export default Tappable;
